import styles from './StatusIndicator.module.css';
import type { SheetProps } from '@mui/joy';
import { Sheet } from '@mui/joy';

export interface StatusIndicatorProps {
  color: SheetProps['color'];
  children?: string;
  className?: string;
  type?: 'subscription' | 'subscriptionLine';
}

function StatusIndicator({
  color,
  children,
  className,
  type = 'subscription',
}: StatusIndicatorProps) {
  let classes = styles[type];
  if (className) {
    classes += ` ${className}`;
  }

  if (!children) {
    return null;
  }

  return (
    <Sheet color={color} component="span" variant="soft" className={classes}>
      {children}
    </Sheet>
  );
}

export default StatusIndicator;
